export const CreateSignHeader = () => {
    return <div className="admin-create-sign-header">Create Your Signature</div>
}